<template>
    <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
      <h2 class="vy-kojin-title">{{ title }}</h2>
      <article style="padding: 0 10px;">
      <!--メインコンテンツ-->
              <hr>
              <!-- パンくずリスト -->
              <nav style="width:100%;--bs-breadcrumb-divider:'>';" aria-label="breadcrumb" v-if="type!=2">
                  <ol class="breadcrumb" style="margin:0">
                      <li class="breadcrumb-item"><a href="#" v-on:click="home">Home</a></li>
                      <li class="breadcrumb-item" ><a href="#" v-on:click="mypage">マイページ</a></li>
                      <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
                  </ol>
              </nav>
       <div id="manual_area" style="margin-bottom:10px">

          <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
          <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

      </div>
      <br clear="all">
  
<div id="download_area" style="width:100%;
    border: 1px solid #000;margin-bottom:10px;
    padding-bottom: 50px;">

        <div style="
            margin-top: 50px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;">

          <div style="margin-bottom:30px;text-align:left">
              <h3>【体験プログラム】チェックイン用二次元コード</h3>
              <span style="margin-left:20px">体験プログラム名：No.{{ taiken.taiken_no_text }}：{{ taiken.name }}</span><br>
              <span style="margin-left:20px">開催期間：{{ DateSetting(taiken.kaisai_start) }}～{{ DateSetting(taiken.kaisai_end) }}</span><br>
              <span style="margin-left:20px" v-if="taiken.shubetsu == 2">届け先：{{ taiken.todokesaki }}</span>
              <div style="text-align:center;font-size:18px"><br>
                分類：{{ taiken.bunrui1 }}
                <template v-if="taiken.bunrui2 != '' && taiken.bunrui2 != null">
                ・{{ taiken.bunrui2 }}
                </template>
              </div><br>
          </div>
          <QRCodeVue3
              v-bind:value=set_url
              :width="200"
              :height="200"
              :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
              :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
              :dotsOptions="{
                type: 'square',
                color: '#000000',
                gradient: {
                  type: 'linear',
                  rotation: 0,
                  colorStops: [
                    { offset: 0, color: '#000000' },
                    { offset: 1, color: '#000000' },
                  ],
                },
              }"
              :backgroundOptions="{ color: '#ffffff' }"
              :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
              :cornersDotOptions="{ type: undefined, color: '#000000' }"
              fileExt="png"
              :download="false"
              myclass="my-qur"
              imgclass="img-qr"
              downloadButton="my-button"
              :downloadOptions="{ name: 'vqr', extension: 'png' }"
            />

        </div>
       
      </div>
      
            <b>※二次元コードが読み取れないときは、画面の明るさを上げてください。</b>
        <br><br>
        <input type="button" value="印刷" v-on:click="qr_download()">

        <br><br>
        ※PDFファイルで保存する場合は、「印刷」ボタンを押した後に「プリンター」を「PDFで保存」に切り替えてください。
  </article>
  </template>
  
  
  <script setup>
  
  /* eslint-disable */
  import { DateSetting,GlobalData } from '../js/userdata.js'
  import { ref,watchEffect } from 'vue'
  import { useRouter } from 'vue-router'
  import QRCodeVue3 from "qrcode-vue3";
  const router = useRouter();
  
  let title = "二次元コード表示"
  
  /* パンくずリストの表示・非表示 */
  
  /* データベース項目。APIから受け取る、または送信する値 */
  /* 分かりやすいようにDBのカラム名と同じ変数名にすること*/
  
  
  // 親コンポーネント（ShakyoTaiken.vue）から送られてきた値

  // taiken_id：表示中の体験プログラムのID
  const props = defineProps(['param']);  
  let taiken_id = props.param.taiken_id
  let user_id = props.param.user_id
  let taiken = props.param.taiken


  let set_url = ref(location.protocol + "//" + location.host + "/" + GlobalData.shakyo_code + "/Taiken/checktaiken/"  + taiken_id + "/" + user_id)
  
  /* コンポーネントの表示に関わる処理 */
  let home = function(){
      router.push('/'+GlobalData.shakyo_code+'/Taiken')
  }
  // パンくずリストのクリックでマイページに戻す
  let mypage = function(){
      router.push('/'+GlobalData.shakyo_code+'/Taiken/mypage')
  }

  let qr_download = function(){
    
    window.document.body.innerHTML = document.getElementById(
        'download_area'
      ).innerHTML  // (1
      window.print()   // (2
      router.go(router.currentRoute.value.path)

    }
  
  /* 親コンポーネントに関わる関数 */
  
  /* その他の関数 */
  
  let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/18cc0be34f8f80c68c27ca80c997c080"
    window.open(url,"_blank")
  }

  let qanda_open = function(){
      let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
      window.open(url,"_blank")

  }

  /* 算出プロパティ */
  
  
  /* 変数の監視 */
  watchEffect(() => {
  
  })
  
  </script>
  
  <style scoped>
  
  
  .error{
    color:red;
  }
  
  #detail_button_area{
    width:100%;
    display: flex;
      justify-content: center;
  }
  
  
  #detail_button_area button{
      width: 30%;
      max-width: 200px;
      margin: 10px;
  }
  
  
  </style>